import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import Header from "@/components/Header";
import InterestForm from "@/components/InterestForm";

const CreatePage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-tl">
      <Header />
      <main className="flex-1 flex flex-col justify-center items-center px-4 py-8">
        <div className="w-full max-w-3xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-extrabold text-center mb-4 text-primary drop-shadow-lg">
          Build Your Perfect Puzzle
          </h1>
          <p className="text-lg text-center mb-6 text-green-800 max-w-2xl mx-auto">
          Generate a crossword from your favorite topics in seconds. Add your interests or pick from our suggestions.
          </p>
          <Card className="bg-white/70 backdrop-blur-[2.5px] rounded-3xl mb-10 shadow-2xl border-0 overflow-hidden p-0">
            <CardContent className="p-0">
              <div className="flex flex-col items-center gap-6 py-8 px-6">
                <InterestForm />
              </div>
            </CardContent>
          </Card>
        </div>
      </main>
      <footer className="mt-auto py-2 sm:py-3 bg-secondary/80" style={{ color: '#283618' }}>
        <div className="container mx-auto px-4 text-center text-sm text-primary">
          <p>© 2025 Crossable. All rights reserved.</p>
          <p className="mt-2">Business inquiries, feedback, or bug reports? Reach us at crossabledev@gmail.com</p>
        </div>
      </footer>
    </div>
  );
};

export default CreatePage;
